export default data => data[0];
